<div class="flxClmn bs-enabled">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container flxRow">
			<span class="page-title">Configuration</span>
			<more-info-c></more-info-c>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">
				Real-time scanning of files, links and messages across Teams, SharePoint and OneDrive
			</span>
		</div>
	</div>
	<div class="page-inner-content-holder gap-3 pt-0 flex-column"
		 [class.no-scroll]="!isConfigTab">
		<!--Tabs — hidden while config is loading or feature is not supported-->
		<div class="md-tabs" *ngIf="isFeatureSupported" [ngStyle]="{'--md-tabs-width': tabWidth + 'px'}">
			<div *ngFor="let tab of dic.CONSTANTS.collaborationProtectionConfigPageTabs | keyvalue: gs.returnZero"
				 [ngClass]="{'selected' : gs.getTabName() === tab.value}"
				 [routerLink]="tab.value" queryParamsHandling="preserve">
				<input type="radio" name="tabs" id="{{tab.key}}Toggle" [checked]="gs.getTabName() === tab.value">
				<label for="{{tab.key}}Toggle">{{tab.value | camelCaseToTitleCase}}</label>
			</div>

			<div class="slide" [ngStyle]="{'left' : tabWidth * _.values(dic.CONSTANTS.collaborationProtectionConfigPageTabs).indexOf(gs.getTabName()) + 'px' || 0}"></div>
		</div>
		<!---->

		<router-outlet (activate)="onRouteActivate($event)"></router-outlet>
	</div>
</div>


